module.exports = __webpack_public_path__ + "static/media/my.e2a97cde.jpg";